const urlOf = (path: string) => `${window.location.origin}${path}`;

const pathwayPath = (inventoryId: number) =>
  `/communities/${inventoryId}/pathways`;

const baselinePath = (inventoryId: number) =>
  `/communities/${inventoryId}/baseline`;

const gpcPath = (inventoryId: number) => `/communities/${inventoryId}/gpc`;

const scenarioPath = (inventoryId: number, scenarioId: number) =>
  `/communities/${inventoryId}/pathways/${scenarioId}`;

export { urlOf, pathwayPath, scenarioPath, baselinePath, gpcPath };
